import Vue from 'vue'
import AppAutosizeTextarea from '../../../components/AppAutosizeTextarea'
import AppInsuranceService from '../../../components/AppInsuranceService'

import lang from 'element-ui/lib/locale/lang/ja'
import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css'
import '../../../../../sass/common/element-variables.scss'
import ElementUIHelper from '../../../element-ui-helper'
import draggable from 'vuedraggable'

locale.use(lang)

Vue.component("app-autoresize-textarea", AppAutosizeTextarea)
Vue.component("app-service-field", AppInsuranceService)

export default (data) => {

    const vm = new Vue({
        el: '#insurance-content',
        components: {
            'draggable': draggable,
        },
        data: data,
        methods: {
            addService: function (index) {
                this.$set(this.insurances, this.insurances.length,
                    [{
                        category_id: this.next_category_id(index),
                        category_name: '',
                        category_description: '',
                        service_id: 1,
                        sort_no: 1,
                        public_flg: 0,
                        service_name: '',
                        contents: ''
                    }]);
                this.$set(this.categories, this.categories.length,
                    {
                        id: this.next_category_id(index),
                        name: '',
                        description: '',
                    });
            },
            addServiceItem: function (index) {
                this.insurances[index].push(
                    {
                        category_id: this.get_category_id(index),
                        service_id: this.next_id(index, 'service_id'),
                        sort_no: this.next_id(index, 'sort_no'),
                        public_flg: 0,
                        service_name: '',
                        contents: ''
                    });
                this.$set(this.insurances, index, this.insurances[index]);
            },
            deleteService(delete_key, modal_id) {
                this.reset_errors(this.categories[delete_key].id);
                this.$delete(this.insurances, delete_key);
                this.$delete(this.categories, delete_key);
                this.modal = $(modal_id);
                this.modal.modal('hide');
            },
            deleteServiceItem: function (index, delete_key, modal_id) {
                this.reset_insurance_errors(this.categories[index].id, this.insurances[index][delete_key].service_id);
                this.insurances[index].splice(delete_key, 1);
                this.$set(this.insurances, index, this.insurances[index]);
                this.modal = $(modal_id);
                this.modal.modal('hide');
            },
            draggableEnd: function (index) {
                Object.keys(this.insurances).map(function () {
                    this.insurances[index].map(function (service, key) {
                        this.reset_insurance_errors(service['category_id'], service['service_id']);
                        service['sort_no'] = service['service_id'] = key + 1;
                        return service;
                    }.bind(this), index);
                }.bind(this), index);
            },
            reset_errors: function (category_id) {
                if ('category_errors' in this.errors) {
                    this.$set(this.errors.category_errors.name, category_id, '');
                }
                if ('insurance_errors' in this.errors) {
                    this.$set(this.errors.insurance_errors.service_name, category_id, []);
                    this.$set(this.errors.insurance_errors.contents, category_id, []);
                }
            },
            reset_insurance_errors: function (category_id, service_id) {
                if ('insurance_errors' in this.errors) {
                    this.$set(this.errors.insurance_errors.service_name[category_id], service_id, '');
                    this.$set(this.errors.insurance_errors.contents[category_id], service_id, '');
                }
            },
        },
        computed: {
            option: function () {
                return function (index) {
                    return {
                        animation: 100,
                        handle: '.drag_handle',
                        ghostClass: 'ghost',
                        group: {
                            name: 'insurance',
                            pull: (this.insurances[index].length > 1),
                            put: (this.insurances[index].length < 9)
                        }
                    };
                }
            },
            next_id: function () {
                return function (index, id_name) {
                    let next_id = (this.insurances[index].length <= 1) ?
                        this.insurances[index][0][id_name] :
                        this.insurances[index].reduce((a, b) => a[id_name] > b[id_name] ? a : b)[id_name];
                    return parseInt(next_id) + 1;
                }
            },
            next_category_id: function () {
                return function (index) {
                    return parseInt(this.insurances[index][0].category_id) + 1;
                }
            },
            get_category_id: function () {
                return function (index) {
                    return this.insurances[index][0]['category_id'];
                }
            },
        }
    });
}
